/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@compiled/react';
import { AppSkeletonImage } from '@jira/platform__skeleton-image-container/src/ui/AppSkeletonImage.tsx';
import { token } from '@atlaskit/tokens';
import imgSVG from './assets/project-list-sidebar-app-skeleton.tpl.svg';

const customCssStyles = css({
	borderLeftWidth: 0,
	borderRightWidth: 0,
});

const sidebarCssStyles = css({
	height: '100%',
	width: '360px',
	paddingTop: token('space.300'),
	paddingRight: token('space.300'),
	paddingBottom: token('space.300'),
	paddingLeft: token('space.300'),
	borderLeftWidth: token('border.width'),
	borderLeftStyle: 'solid',
	borderLeftColor: token('color.border'),
	backgroundColor: token('elevation.surface'),
	boxSizing: 'border-box',
});

export const ProjectListSidebarSkeleton = (): JSX.Element => (
	<div css={sidebarCssStyles}>
		<AppSkeletonImage src={imgSVG} css={customCssStyles} />
	</div>
);
